import { Game } from '../sites/GameComposer/GameCard';
import axiosInstance from './axios';

// Mock in-memory storage for games
let mockGames: Game[] = [];

// Simulate network delay
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const bonusFreeSpinsService = {
  getFreeSpinsGames: async (siteId: string | number): Promise<any> => {
    const response = await axiosInstance.get(`/admin/games/free-spin-bonus-games`, {
      params: { siteId },
    });
    return response.data;
  },

  addGame: async (siteId: string | number, game: Game): Promise<{ data: Game[] }> => {
    await delay(300);
    if (mockGames.length >= 3) {
      throw new Error('Maximum of 3 games allowed');
    }
    if (mockGames.some((g) => g.id === game.id)) {
      throw new Error('Game already added');
    }
    mockGames.push(game);
    return { data: [...mockGames] };
  },

  removeGame: async (
    siteId: string | number,
    gameId: string | number,
  ): Promise<{ data: Game[] }> => {
    await delay(300);
    mockGames = mockGames.filter((g) => String(g.id) !== String(gameId));
    return { data: [...mockGames] };
  },

  reorderGames: async (
    siteId: string | number,
    gameIds: (string | number)[],
  ): Promise<{ data: Game[] }> => {
    await delay(300);
    const newOrder: Game[] = [];
    gameIds.forEach((id) => {
      const game = mockGames.find((g) => String(g.id) === String(id));
      if (game) newOrder.push(game);
    });
    mockGames = newOrder;
    return { data: [...mockGames] };
  },

  saveFreeSpinsGames: async (siteId: string | number, games: Game[]): Promise<any> => {
    const gameIds = games.map((g) => Number((g as any).gameId || (g as any).game?.id || g.id));
    const response = await axiosInstance.put(`/admin/games/free-spin-bonus-games`, {
      siteId: Number(siteId),
      gameIds,
    });
    return response.data;
  },
};
